module.exports = __webpack_public_path__ + "img/v_denied.f7433ef1.svg";